export { default } from './product-image';
